/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { InstallationWizardCompletedStep } from './InstallationWizardCompletedStep';
import {
    InstallationWizardCompletedStepFromJSON,
    InstallationWizardCompletedStepFromJSONTyped,
    InstallationWizardCompletedStepToJSON,
} from './InstallationWizardCompletedStep';
import type { InstallationConfigDtoEmailSettings } from './InstallationConfigDtoEmailSettings';
import {
    InstallationConfigDtoEmailSettingsFromJSON,
    InstallationConfigDtoEmailSettingsFromJSONTyped,
    InstallationConfigDtoEmailSettingsToJSON,
} from './InstallationConfigDtoEmailSettings';

/**
 * 
 * @export
 * @interface InstallationConfigDto
 */
export interface InstallationConfigDto {
    /**
     * 
     * @type {string}
     * @memberof InstallationConfigDto
     */
    customerProvidedOptionalSiteName?: string | null;
    /**
     * 
     * @type {InstallationConfigDtoEmailSettings}
     * @memberof InstallationConfigDto
     */
    emailSettings?: InstallationConfigDtoEmailSettings | null;
    /**
     * 
     * @type {string}
     * @memberof InstallationConfigDto
     */
    defaultConnectionString: string;
    /**
     * 
     * @type {string}
     * @memberof InstallationConfigDto
     */
    blobStoringConnectionString: string;
    /**
     * 
     * @type {string}
     * @memberof InstallationConfigDto
     */
    integratedDefaultConnectionString: string;
    /**
     * 
     * @type {string}
     * @memberof InstallationConfigDto
     */
    integratedBlobConnectionString: string;
    /**
     * 
     * @type {boolean}
     * @memberof InstallationConfigDto
     */
    isCustomDatabaseUsed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InstallationConfigDto
     */
    csoPortalUrl: string;
    /**
     * 
     * @type {InstallationWizardCompletedStep}
     * @memberof InstallationConfigDto
     */
    completedStep?: InstallationWizardCompletedStep;
    /**
     * 
     * @type {string}
     * @memberof InstallationConfigDto
     */
    $type?: InstallationConfigDtoTypeEnum;
}


/**
 * @export
 */
export const InstallationConfigDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedInstallDtoInstallationConfigDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Install.Dto.InstallationConfigDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type InstallationConfigDtoTypeEnum = typeof InstallationConfigDtoTypeEnum[keyof typeof InstallationConfigDtoTypeEnum];



/**
 * Check if a given object implements the InstallationConfigDto interface.
 */
export function instanceOfInstallationConfigDto(value?: unknown): value is InstallationConfigDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(InstallationConfigDtoTypeEnum)[0];
}

export function InstallationConfigDtoFromJSON(json: any): InstallationConfigDto {
    return InstallationConfigDtoFromJSONTyped(json, false);
}

export function InstallationConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstallationConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'customerProvidedOptionalSiteName': json['customerProvidedOptionalSiteName'] == null ? undefined : json['customerProvidedOptionalSiteName'],
        'emailSettings': json['emailSettings'] == null ? undefined : InstallationConfigDtoEmailSettingsFromJSON(json['emailSettings']),
        'defaultConnectionString': json['defaultConnectionString'],
        'blobStoringConnectionString': json['blobStoringConnectionString'],
        'integratedDefaultConnectionString': json['integratedDefaultConnectionString'],
        'integratedBlobConnectionString': json['integratedBlobConnectionString'],
        'isCustomDatabaseUsed': json['isCustomDatabaseUsed'] == null ? undefined : json['isCustomDatabaseUsed'],
        'csoPortalUrl': json['csoPortalUrl'],
        'completedStep': json['completedStep'] == null ? undefined : InstallationWizardCompletedStepFromJSON(json['completedStep']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function InstallationConfigDtoToJSON(value?: InstallationConfigDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'customerProvidedOptionalSiteName': value['customerProvidedOptionalSiteName'],
        'emailSettings': InstallationConfigDtoEmailSettingsToJSON(value['emailSettings']),
        'defaultConnectionString': value['defaultConnectionString'],
        'blobStoringConnectionString': value['blobStoringConnectionString'],
        'integratedDefaultConnectionString': value['integratedDefaultConnectionString'],
        'integratedBlobConnectionString': value['integratedBlobConnectionString'],
        'isCustomDatabaseUsed': value['isCustomDatabaseUsed'],
        'csoPortalUrl': value['csoPortalUrl'],
        'completedStep': InstallationWizardCompletedStepToJSON(value['completedStep']),
        '$type': value['$type'],
    });
}

